import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "section__container" }
const _hoisted_2 = { class: "section__input__container" }
const _hoisted_3 = { key: 0 }

import { i18n } from '@/i18n';
import TextInput from '@/unmanagedBusinessModule/components/TextInput.vue';
import SimpleSelectInput from '@/corePagesModule/components/SelectInput.vue';
import TextIconButton from '@/corePagesModule/components/TextIconButton.vue';
import { useAddOptionSection } from '@/corePagesModule/updateBusinessModal/composables/useAddOptionSection';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddOptionWideSection',
  props: {
    isAggregateBusiness: { type: Boolean },
    options: { default: () => [] },
    disabled: { type: Boolean }
  },
  emits: ["setOption"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "57c9f2f6": (_unref(optionFieldCount))
}))

const t = i18n.t;

// eslint-disable-next-line jsdoc/require-jsdoc
const props = __props;

const emits = __emit;

const {
  fieldState,
  isAnotherInputShow,
  optionFieldCount,
  isAddButtonActive,
  textStyle,
  buttonStyle,
  AddableOptions,
  updateInput,
  addOption,
} = useAddOptionSection(emits, { isAggregateBusiness: props.isAggregateBusiness, customOption: props.options });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TextInput, {
          class: "section__input",
          "model-value": _unref(fieldState)['value'].value.value,
          label: "",
          placeholder: _unref(t)('新規選択肢'),
          "is-error": _unref(fieldState)['value'].isError.value,
          "error-message": _unref(fieldState)['value'].errorMessage.value,
          disabled: _ctx.disabled,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = 
            (e) => {
              _unref(updateInput)(e, 'value');
            }
          )
        }, null, 8, ["model-value", "placeholder", "is-error", "error-message", "disabled"]),
        _createElementVNode("span", {
          style: _normalizeStyle(_unref(textStyle))
        }, _toDisplayString(_unref(t)('を')), 5),
        _createVNode(SimpleSelectInput, {
          class: "section__input",
          "model-value": _unref(fieldState)['option'].value.value,
          index: 99,
          label: "",
          options: _unref(AddableOptions),
          "select-box-name": "SELECT_COLUMN_FOR_NEW_SELECTION",
          placeholder: _unref(t)('必須項目から選択'),
          "display-allow": "",
          disabled: _ctx.disabled,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = 
            (e) => {
              _unref(updateInput)(e, 'option');
            }
          )
        }, null, 8, ["model-value", "options", "placeholder", "disabled"]),
        _createElementVNode("span", {
          style: _normalizeStyle(_unref(textStyle))
        }, [
          _createTextVNode(_toDisplayString(_unref(t)('として')), 1),
          (_unref(isAnotherInputShow))
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('、')), 1))
            : _createCommentVNode("", true)
        ], 4),
        (_unref(isAnotherInputShow))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(TextInput, {
                class: "section__input",
                "model-value": _unref(fieldState)['anotherValue'].value.value,
                label: "",
                placeholder: _unref(t)('新規選択肢'),
                "is-error": _unref(fieldState)['anotherValue'].isError.value,
                "error-message": _unref(fieldState)['anotherValue'].errorMessage.value,
                disabled: _ctx.disabled,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = 
              (e) => {
                _unref(updateInput)(e, 'anotherValue');
              }
            )
              }, null, 8, ["model-value", "placeholder", "is-error", "error-message", "disabled"]),
              _createElementVNode("span", {
                style: _normalizeStyle(_unref(textStyle))
              }, _toDisplayString(_unref(t)('を')), 5),
              _createVNode(TextInput, {
                class: "section__input",
                "model-value": _unref(fieldState)['anotherOption'].value.value,
                label: "",
                disabled: ""
              }, null, 8, ["model-value"]),
              _createElementVNode("span", {
                style: _normalizeStyle(_unref(textStyle))
              }, _toDisplayString(_unref(t)('として')), 5)
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          style: _normalizeStyle(_unref(textStyle))
        }, _toDisplayString(_unref(t)('上記のセクションに新規選択肢を追加できます。')), 5),
        _createVNode(TextIconButton, {
          style: _normalizeStyle(_unref(buttonStyle)),
          text: _unref(t)('追加'),
          icon: "plusIconWhite",
          "prop-disabled": !_unref(isAddButtonActive),
          onClick: _unref(addOption)
        }, null, 8, ["style", "text", "prop-disabled", "onClick"])
      ])
    ])
  ]))
}
}

})